



import CarpsaleListComponent from "@/components/admin/carpsale/carpsaleListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "CarpsaleListPage",
  components: {
    CarpsaleListComponent,
  },
})
export default class CarpsaleListPage extends Vue {}
